var map = {
	"./decidim/avatar-multiuser.png": 92199,
	"./decidim/brands/google.svg": 66046,
	"./decidim/cc-badge.png": 19725,
	"./decidim/decidim-logo.svg": 33877,
	"./decidim/default-avatar.svg": 76917,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 26443,
	"./decidim/icons.svg": 21348,
	"./decidim/pattern.png": 7831,
	"./decidim/placeholder-card-g.svg": 46220,
	"./decidim/placeholder-card-l.svg": 34839,
	"./decidim/placeholder.jpg": 81230,
	"./decidim/remixicon.symbol.svg": 13124,
	"./decidim/vendor/leaflet/layers-2x.png": 60909,
	"./decidim/vendor/leaflet/layers.png": 68660,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 78085,
	"./decidim/vendor/leaflet/marker-icon.png": 97468,
	"./decidim/vendor/leaflet/marker-shadow.png": 83875,
	"./decidim/vendor/social-share-button/douban.svg": 3895,
	"./decidim/vendor/social-share-button/email.svg": 16960,
	"./decidim/vendor/social-share-button/facebook.svg": 51132,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 78520,
	"./decidim/vendor/social-share-button/hacker_news.svg": 85556,
	"./decidim/vendor/social-share-button/linkedin.svg": 58310,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 53599,
	"./decidim/vendor/social-share-button/pinterest.svg": 16270,
	"./decidim/vendor/social-share-button/reddit.svg": 53764,
	"./decidim/vendor/social-share-button/telegram.svg": 11945,
	"./decidim/vendor/social-share-button/tumblr.svg": 20966,
	"./decidim/vendor/social-share-button/twitter.svg": 7645,
	"./decidim/vendor/social-share-button/vkontakte.svg": 35903,
	"./decidim/vendor/social-share-button/wechat.svg": 78474,
	"./decidim/vendor/social-share-button/whatsapp.svg": 79882,
	"./decidim/vendor/social-share-button/x.svg": 16448,
	"./decidim/vendor/social-share-button/xing.svg": 78408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 886;